import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { ClienteContext } from 'app/main/cliente/ClienteContext';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext } from 'react';
import { clienteModais } from '../clienteModais';
import ClienteBuscaAvancadaForm from './ClienteBuscaAvancadaForm';

const ClienteBuscaAvancadaModal = ({ fetchClientes }) => {
  const [modal, setModal] = useContext(ClienteContext).modal;
  const [filtroAvancado, setFiltroAvancado] = useContext(ClienteContext).filtroAvancado;
  const [search] = useContext(ClienteContext).search;
  const [size] = useContext(ClienteContext).size;
  const [sort] = useContext(ClienteContext).sort;

  const handleSubmit = (values) => {
    setFiltroAvancado(values);

    const filtroAvancado = {
      ...values,
      uf: values?.pessoa?.endereco?.uf?.nome,
    };

    delete filtroAvancado.uf;

    fetchClientes({ q: search, filtroAvancado, size, sort });
    setModal('');
  };

  const handleCancelar = () => {
    const close = () => {
      formik.resetForm(formik.initialValues);
      setModal('');
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const formik = useFormik({
    initialValues: {
      nome: filtroAvancado.nome,
      razaoSocial: filtroAvancado.razaoSocial,
      cpfCnpj: filtroAvancado.cpfCnpj,
      email: filtroAvancado.email,
      uf: filtroAvancado.uf,
      cidade: filtroAvancado.cidade,
    },
    onSubmit: handleSubmit,
  });

  return (
    <SimpleDialog open={modal === clienteModais.buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<ClienteBuscaAvancadaForm />}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ClienteBuscaAvancadaModal;
